export default __webpack_public_path__ + "5add6f9.png";